<template>
  <el-select
    v-model="input"
    :remote-method="querySearch"
    placeholder="Enter name of Account"
    :trigger-on-focus="false"
    multiple
    filterable
    remote
    class="w-100"
    placement="top"
    clearable
    :loading="isLoading"
    value-key="id"
    @change="handleSelect"
  >
    <el-option
      v-for="item in data"
      :key="item.id"
      :label="item.name"
      :value="item"
    />
  </el-select>
</template>

<script>
export default {
  data () {
    return {
      input: '',
      data: [],
      isLoading: false,
      carrier_settings: []
    }
  },
  methods: {
    querySearch (queryString, cb) {
      this.isLoading = true
      this.$sdk.account.list(builder => {
        builder.filters = { account_name: queryString, account_active: 1 }
        builder.include = 'carrier_settings.carrier'
      }).then(res => {
        this.isLoading = false
        this.data = res
      })
    },
    handleSelect (item) {
      this.carrier_settings = []
      let carrierSettings = []
      let map = new Map()

      item.forEach(function (e) {
        carrierSettings = carrierSettings.concat(e.carrier_settings)
      })
      for (let item of carrierSettings) {
        if (!map.has(item.carrier.id)) {
          map.set(item.carrier.id, item.carrier.id)
          this.carrier_settings.push(item)
        }
      }

      this.$emit('loadCarrier')
    },
    getAccountIds () {
      return Object.keys(this.input).map(key => {
        if (this.input[key].id) {
          return this.input[key].id
        }
      }).filter(Boolean).join(',')
    },
    getCarriers () {
      return this.carrier_settings
    }
  }
}
</script>

<style>

</style>
